"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToOrRemoveFromListContent = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _esToolkit = require("es-toolkit");
var _xor = _interopRequireDefault(require("es-toolkit/compat/xor"));
var _react = require("react");
var _api = require("../../api");
var _constants = require("../../constants");
var _favoritesContext = require("../../contexts/favoritesContext");
var _hooks = require("../../hooks");
var _FavoritesDialogContent = require("./FavoritesDialogContent");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AddToOrRemoveFromListContent = ({
  onClose
}) => {
  const [saving, setSaving] = (0, _react.useState)(false);
  const [selectedListIds, setSelectedListIds] = (0, _react.useState)([]);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    lists,
    lastUsedProductCode,
    lastUsedProductCodeInLists,
    maximumAllowedPersonalLists,
    createList,
    openSnackbar,
    toggleProductInLists
  } = (0, _favoritesContext.useFavorites)();
  const {
    arePersonalListsEnabled
  } = (0, _api.useGetFeatureToggle)();
  const changedListIds = (0, _xor.default)(selectedListIds, lastUsedProductCodeInLists);
  (0, _react.useEffect)(() => {
    if (selectedListIds.length === 0) {
      setSelectedListIds(lastUsedProductCodeInLists);
    }
    // eslint-disable-next-line react-compiler/react-compiler -- We only want to run this effect once
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to run this effect once
  }, []);
  const onChange = (0, _react.useCallback)(event => {
    setSelectedListIds(prev => {
      const updated = new Set(prev);
      if (event.target.checked) {
        updated.add(event.target.value);
      } else {
        updated.delete(event.target.value);
      }
      return [...updated];
    });
  }, []);
  const onSave = (0, _react.useCallback)(async () => {
    setSaving(true);
    try {
      const wasRemoved = (0, _esToolkit.difference)(lastUsedProductCodeInLists, selectedListIds).length > 0;
      const eventName = wasRemoved ? _constants.ANALYTICS_FAVORITES_REMOVE : _constants.ANALYTICS_FAVORITES_ADD;
      UserAction.dispatch([eventName, window.location.pathname, lastUsedProductCode]);
      await toggleProductInLists({
        productCode: lastUsedProductCode,
        productListIds: changedListIds
      });
      openSnackbar((0, _utils.getSnackbarMessage)({
        lastUsedProductCodeInLists,
        selectedListIds,
        translations
      }));
    } catch (error) {
      openSnackbar(translations.saveFailed);
    } finally {
      setSaving(false);
      onClose();
    }
  }, [changedListIds, lastUsedProductCode, lastUsedProductCodeInLists, onClose, openSnackbar, selectedListIds, toggleProductInLists, translations]);
  const onCreateList = (0, _react.useCallback)(() => {
    createList({
      productCodes: [lastUsedProductCode],
      shouldRedirectOnSuccess: true
    });
  }, [createList, lastUsedProductCode]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FavoritesDialogContent.FavoritesDialogContent, {
    testId: getTestId(_constants2.ADD_TO_OR_REMOVE_FROM_LIST_CONTENT),
    buttons: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        color: "primary",
        variant: "contained",
        disabled: changedListIds.length === 0,
        loading: saving,
        onClick: onSave,
        children: translations.save
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        variant: "text",
        loading: saving,
        onClick: onClose,
        children: translations.cancel
      })]
    }),
    content: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.FormGroup, {
      children: [lists.map(list => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
          title: (0, _utils.isCheckboxDisabled)({
            productCode: lastUsedProductCode,
            list,
            selectedListIds
          }) ? translations.productsLimitReached : '',
          placement: "bottom",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormControlLabel, {
            control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Checkbox, {
              checked: selectedListIds.includes(list.id),
              disabled: (0, _utils.isCheckboxDisabled)({
                productCode: lastUsedProductCode,
                list,
                selectedListIds
              }),
              name: list.name,
              value: list.id,
              onChange: onChange
            }),
            label: list.type === 'Favorite' ? translations.myFavourites : list.name
          }, list.id)
        }), lists.length > 1 && list.type === 'Favorite' || lists.length === 1 && arePersonalListsEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Separator, {}) : null]
      })), arePersonalListsEnabled && lists.length - 1 < maximumAllowedPersonalLists ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
        textAlign: "left",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          "data-testid": getTestId(_constants2.CREATE_NEW_LIST_BUTTON),
          variant: "text",
          size: "small",
          onClick: onCreateList,
          children: translations.createNewList
        })
      }) : null]
    }),
    message: translations.addToListDialogMessage
  });
};
exports.AddToOrRemoveFromListContent = AddToOrRemoveFromListContent;
//# sourceMappingURL=AddToOrRemoveFromListContent.js.map